var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loading d-flex text-center" }, [
    _c("div", { staticClass: "loading-animation m-auto" }, [
      _c(
        "svg",
        {
          staticClass: "icon icon-loader",
          attrs: { width: "32", height: "32", fill: "currentColor" },
        },
        [_c("use", { attrs: { "xlink:href": "#loader" } })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }